<template>
  <div>
    <div class="mapwrap">
      <div @click="$emit('mapClick')" v-if="!nameShow" class="maphover"></div>
      <div id="tmap"></div>
      <div class="fixbuild" @click="locationClick()"><i class="el-icon-aim"></i><a>定位楼盘</a></div>
    </div>
    <div class="maptypewrap">
      <div class="maptype">
        <span :class="maptypeCurr==0?'active':''" @click="maptypeClick(0)"><i class="m-icon mi-gj"></i>公交</span>
        <span :class="maptypeCurr==1?'active':''" @click="maptypeClick(1)"><i class="m-icon mi-dt"></i>地铁</span>
        <span :class="maptypeCurr==2?'active':''" @click="maptypeClick(2)"><i class="m-icon mi-xx"></i>学校</span>
        <span :class="maptypeCurr==3?'active':''" @click="maptypeClick(3)"><i class="m-icon mi-yy"></i>医院</span>
        <span :class="maptypeCurr==4?'active':''" @click="maptypeClick(4)"><i class="m-icon mi-gw"></i>购物</span>
      </div>
      <div class="mtypebox" v-if="!nameShow">
        <p v-if="markers.length==0" class="noresult">{{msg}}</p>
        <ul v-for="(item, index) in markers" :key="index" v-if="index<5">
          <li>
            <em v-if="maptypeCurr==0">{{index+1}}.【公交】</em>
            <em v-if="maptypeCurr==1">{{index+1}}.【地铁】</em>
            <em v-if="maptypeCurr==2">{{index+1}}.【学校】</em>
            <em v-if="maptypeCurr==3">{{index+1}}.【医院】</em>
            <em v-if="maptypeCurr==4">{{index+1}}.【购物】</em>{{item.name}}<span>{{item.distance}}米</span>
          </li>
        </ul>
      </div>
      <div class="leave-box" @click="$emit('leaveClick',7)"><span>了解区域房价走势</span></div>
    </div>
  </div>
</template>

<script>
import TMap from '../store/tianMap.js';
export default {
  name:'Maps',
  components:{
    'scriptLink': {
      render(createElement) {
        return createElement(
          'script',
          {
            attrs: {
              type: 'text/javascript',
              src: 'https://api.tianditu.gov.cn/api?v=4.0&tk=cb8b38089bbfbc5b88cac1ca896a1d60',
            },
          },
        )
      }
    }
  },
  props:{
    bcenter:Object,
    nameShow:Boolean,
  },
  data () {
    return {
      isPC:this.$store.state.isPC,
      maptypeCurr:0,
      markers:[],
      markersParam:'公交站',
      showMarker:true,
      msg:'正在加载...',
      tlng:TMap.getLngLat(this.bcenter.lng,this.bcenter.lat)[0],
      tlat:TMap.getLngLat(this.bcenter.lng,this.bcenter.lat)[1],
      center:'',
      map:'',
      searchT:'',
      zoom:this.bcenter.level-1,
    }
  },
  computed:{
    listenIsPC(){
      return this.$store.state.isPC;
    }
  },
  watch:{
    listenIsPC:function(boo){
      this.isPC = this.$store.state.isPC;
    }
  },
  mounted(){
    this.roadMap();
  },
  methods:{

    roadMap(){
      var that = this;
      TMap.init().then(T=>{
        that.center = new T.LngLat(that.tlng,that.tlat);
        that.map = new T.Map('tmap');
        that.map.centerAndZoom(that.center, that.zoom);
        var control = new T.Control.Zoom();
        that.map.addControl(control);


        var config = {
          pageCapacity: 15,  //每页显示的数量
          onSearchComplete: function(result){
            var res=result.getPois();
            that.markers=TMap.filterMarkers(res,that.maptypeCurr);
            if(that.markers.length==0){
              that.msg="暂无相关配套信息"
            }
            that.renderMarkers()
          } //接收数据的回调函数
        };
        that.searchT = new T.LocalSearch(that.map, config);
        that.searchMarkers();
      }).catch()

    },

    maptypeClick:function(index){
      this.maptypeCurr = index;
      if(this.maptypeCurr == 1){
        this.markersParam = '-地铁站'
      }else if(this.maptypeCurr == 2){
        this.markersParam = 'school'
      }else if(this.maptypeCurr == 3){
        this.markersParam = 'hospital'
      }else if(this.maptypeCurr == 4){
        this.markersParam = 'shopping'
      }else{
        this.markersParam = '-公交站'
      }
      this.searchMarkers();
    },
    locationClick:function(){
      this.showMarker = false
      this.$nextTick(() => (this.showMarker = true))
    },
    searchMarkers:function(){
      this.map.clearOverLays();
      this.map.centerAndZoom(this.center, this.zoom);
      this.searchT.searchNearby(this.markersParam,this.center,2000);
      var label = new T.Label({
        text: this.bcenter.name+"<div class='zx'></div>",
        position: this.center,
        offset: new T.Point(-36, -20)
      });
      this.map.addOverLay(label);
    },
    renderMarkers:function(){
      for (var i = 0; i < this.markers.length; i++) {
        var icon = new T.Icon({
          iconUrl: "https://api.tianditu.gov.cn/v4.0/image/marker-icon.png",
          iconSize: new T.Point(13, 21),
          iconAnchor: new T.Point(3, 19)
        });
        var p=this.markers[i].lonlat.split(' ');
        var pp=new T.LngLat(p[0],p[1]);
        var pm=new T.Marker(pp,{icon: icon})
        this.map.addOverLay(pm);
        this.addClickHandler(this.markers[i].name,pm,this.map);
      }
    },
    addClickHandler:function(content,marker,map){
      marker.addEventListener("click",function(e){
        var point = e.lnglat;
        marker = new T.Marker(point);
        var markerInfoWin = new T.InfoWindow(content,{offset:new T.Point(4,-13)});
        map.openInfoWindow(markerInfoWin,point);
      });
    },
  }
}
</script>


<style scoped>
#tmap{width:100%;height:100%}
#tmap >>> img{display:inline;}
#tmap >>> .tdt-overlay-pane{z-index:700}
#tmap >>> .tdt-label{box-shadow:0 2px 6px 0 rgba(0,0,0,.2);line-height:22px;font-size:12px;border-radius:2px;border:0;}
#tmap >>> .tdt-label:first-child{line-height:30px;font-size:13px;background:#BA2328;color:#fff;}
#tmap >>> .tdt-label .zx0{display:inline-block;padding:13px;width:16px;height:16px;background:rgba(255,86,74,.2);border-radius:50%;position:absolute;bottom:-50px;left:0;}
#tmap >>> .tdt-label .zx0:after{content:'';display:block;width:100%;height:100%;background:#FF564A;border-radius:50%;}
#tmap >>> .tdt-label .zx{display:inline-block;border:7px solid transparent;border-top-color:#ba2328;position:absolute;bottom:-14px;left:15px;}
#tmap >>> .tdt-control-copyright{font-size:0}

.mapwrap{height:200px;background:#f5f3f0;margin-top:15px;border-radius:8px;border:1px solid #e0e0e0;overflow:hidden;position:relative;z-index:1}
.maptype{display:flex;width:100%;margin-top:15px;justify-content:space-between;margin-bottom:10px;}
.maptype span{text-align:center;}
.maptype .m-icon{width:45px;height:45px;display:block;margin:0 auto 3px;}
.mi-gj{background-position:0 -148px;}
.mi-dt{background-position:-45px -148px;}
.mi-xx{background-position:-90px -148px;}
.mi-yy{background-position:-135px -148px;}
.mi-gw{background-position:-180px -148px;}
.active .mi-gj{background-position:0 -193px;}
.active .mi-dt{background-position:-45px -193px;}
.active .mi-xx{background-position:-90px -193px;}
.active .mi-yy{background-position:-135px -193px;}
.active .mi-gw{background-position:-180px -193px;}
.noresult{text-align:center;padding:20px 0;color:#999;border-top:1px solid #e9e9e9;}
.mtypebox li{line-height:44px;height:44px;border-top:1px solid #e9e9e9;padding-right:70px;font-size:14px;position:relative;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.mtypebox li em{font-style:normal;color:#888;float:left;}
.mtypebox li span{position:absolute;right:0;top:0;color:#888;}
.mtypebox+.leave-box{margin-top:10px;}
.fixbuild{background:#313131;color:#fff;line-height:30px;height:30px;width:30px;text-align:center;border-radius:25px;position:absolute;right:5px;top:5px;overflow:hidden;font-size:14px;z-index:2;cursor:pointer;}
.fixbuild a{display:none;margin-left:8px;}
.fixbuild i{font-size:20px;margin-top:5px;}
.maphover{position:absolute;left:0;right:0;top:0;bottom:0;z-index:1;}
@media (min-width:769px){
  .mapwrap{height:470px;margin-top:25px;}
  .maptypewrap{position:absolute;z-index:2;right:30px;top:85px;background:#fff;border-radius:5px;box-shadow:0 2px 4px 0 rgba(0,0,0,.12),0 0 6px 0 rgba(0,0,0,.04);border:1px solid #dcdfe6;padding:0 20px 10px;width:300px;}
  .fixbuild{line-height:48px;height:48px;padding:0 12px;right:auto;top:auto;bottom:20px;left:40%;width:auto;font-size:14px;z-index:2;}
  .fixbuild i{font-size:24px;float:left;margin-top:12px;}
  .fixbuild:hover a{display:inline}
  .maphover{display:none;}

  .leave-box{position:static;margin-bottom:10px;}
  .leave-box span{width:100%}
}
</style>



// WEBPACK FOOTER //
// src/components/Maps.vue